module.exports = __webpack_public_path__ + "img/lawyer.0a520f6b.svg";